import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

const ContactsListViewParts = [
  'vstack',
  'toggleButton',
  'searchContainer',
  'dropdownContainer',
  'listContainer',
  'scrollingList',
] as const

const helpers = createMultiStyleConfigHelpers(ContactsListViewParts)

export const ContactsListViewStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    vstack: {
      display: 'flex',
      height: '100%',
      alignSelf: 'stretch',
      gap: '2px',
      borderRight: '2px solid',
      borderColor: 'border.muted',
    },
    toggleButton: {
      width: 'full',
      minHeight: '2rem',
      bg: 'bg.subtle',
    },
    searchContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      alignSelf: 'stretch',
      backgroundColor: 'bg.default',
    },
    dropdownContainer: {
      width: '100%',
      padding: '1rem',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '1.25rem',
      alignSelf: 'stretch',
      backgroundColor: 'bg.default',
      zIndex: 1,
    },
    scrollingList: {
      display: 'flex',
      flex: '1',
      width: '100%',
      height: '70%',
      backgroundColor: 'bg.default',
      paddingX: '0.25rem',
      paddingY: '0.75rem',
    },
  },
})

export const useContactsListViewStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(ContactsListViewStyle, props) as MultiStyleType<
    typeof ContactsListViewParts
  >
}
